import React, { Component } from "react";
import { Container } from "./yuvaContainer";
import styled from "styled-components";
class Schemes extends Component{
    render()
    {
        const ProgramTitle = styled.text`
            color: #333333;
            font-family: Lato;
            font-size: 18px;
            font-weight: 600;
            line-height: 25px;
            text-transform: uppercase;
        `;
        const ProgramDisc = styled.div`
            color: #666666;
            font-family: Lato;
            font-size: 16px;
            line-height: 31px;
            padding: 1em 0 2em 0;
        `;
        const ProgramBtn = styled.div`
        text-transform: capitalize;`;
        const ProgramImg =styled.img`
        width: 100%`;
       
        return(


                <div className="row pb-5" >
            
                  <div className="col-sm-12 col-lg-5">
                     <ProgramImg src={this.props.programImage} alt="DyesProgramImg"/>
                  </div>
                  <div className="col-sm-12 col-lg-7 pl-lg-5 ProgramTile">
                     <ProgramTitle>
                     {this.props.ProgramTitle}
                     </ProgramTitle>
                     <ProgramDisc>
                     {this.props.Programdisc}
                     </ProgramDisc>
                     <ProgramBtn>
                    {this.props.link ? 
                    (<a href={this.props.link} target="_blnak">
                     <button className="infoCtaRedbutton ">
                       <span>{this.props.btntext}</span>
                     </button>
                     </a>)
                    : ("")}
                     </ProgramBtn>
                  </div>
               </div>
        )
    }
}

export default Schemes;
